import {apiFetch} from '../_helpers';


export const highlightsService = {
    getAll,
};


function getAll() {
    return apiFetch("highlights/");
}